export const AiTaggingTourApi = Symbol('AiTaggingTourApi');
